import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HorizontalSplitIcon(props: IconProps) {
    return <Icon {...props} iconKey={"horizontal_split"}/>
}
